module.exports = __webpack_public_path__ + "img/texture2.392bab43.jpeg";